const theme = {}

export { theme }
